<template>
  <div class="mall-round-tabs">
    <div class="mall-round-tabs__inner">
      <div
        v-for="tab in tabs"
        :key="tab.key"
        class="mall-round-tabs__tab"
        :class="{ 'mall-round-tabs__tab--active': tab.key === value }"
        @click="$emit('change', tab.key)"
      >
        {{ tab.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MallRoundTabs',
  props: {
    // [{ key, label }]
    tabs: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
/* 좌우 16px 여백을 가진 영역 안에서 화면 끝까지 가로 스크롤 */
.mall-round-tabs {
  margin: 0 -16px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.mall-round-tabs::-webkit-scrollbar {
  display: none;
}

.mall-round-tabs__inner {
  display: flex;
  width: max-content;
  padding: 0 16px;
  gap: 4px;
}

.mall-round-tabs__tab {
  padding: 7px 11px;
  border: 1px solid #E5E8EB;
  border-radius: 10000px;
  background: #F2F4F6;
  color: #4E5968;
  font-family: Pretendard;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  white-space: nowrap;
  cursor: pointer;
}

.mall-round-tabs__tab--active {
  border-color: #333D4B;
  background: #333D4B;
  color: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallRoundTabs.vue